module.exports = __webpack_public_path__ + "img/productSatellite_21.c7489502.png";